import cx from 'classnames';
import { string, func } from 'prop-types';
import * as styles from './giftCardRedemption.module.scss';

const RedeemForm = ({ handleSubmit, setInput, inputValue, customerMessage, errorMessage }) => (
  <section>
    <div id="frmRedeemGift" className={styles.formRedeemGift}>
      <form onSubmit={handleSubmit} data-testid="redeem-form">
        <div>
          <div className="form-group">
            <input
              id="redemption_code"
              className={styles.redemptionCodeInput}
              type="text"
              placeholder="Enter your code here"
              onChange={({ target }) => setInput(target.value)}
              value={inputValue}
            />
          </div>
          <div className="form-group">
            <button className={styles.submitButton} type="submit" disabled={!inputValue}>
              REDEEM
            </button>
          </div>
          {(errorMessage || customerMessage) && (
            <div className="d-foot">
              <div className={cx(errorMessage ? styles.formError : styles.formSuccess)}>
                {errorMessage || customerMessage}
              </div>
            </div>
          )}
        </div>
      </form>
    </div>
  </section>
);

RedeemForm.defaultProps = {
  handleSubmit: () => null,
  setInput: () => null,
  inputValue: '',
  customerMessage: '',
  errorMessage: '',
};

RedeemForm.propTypes = {
  handleSubmit: func,
  setInput: func,
  inputValue: string,
  customerMessage: string,
  errorMessage: string,
};

export default RedeemForm;
